import { Card, Descriptions, Typography } from 'antd';
import React from 'react';
import { FormatDate } from '../../../../../../constants';
import { CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment } from '../../../../../../generated';
import { LegalCertification } from '../../../../../shared/legal_certification/legal-certification';


export interface ApplicantDetailsSummaryProps {
  applicationDetails: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment;
}

export const ApplicantDetailsSummary: React.FC<ApplicantDetailsSummaryProps> = (props) => {
  return (
    <Card>
      <Typography.Text style={{ fontSize: '20px' }}>Applicant Provided Details</Typography.Text>
      <Descriptions layout="vertical" style={{ marginTop: 20 }} title={<Typography.Text style={{ fontSize: '16px' }}>What type of credential is it?</Typography.Text>}>
        <Descriptions.Item contentStyle={{ paddingLeft: '18px' }}>
          <Typography.Text style={{ marginTop: -10 }}>{props.applicationDetails?.credentialType || 'N/A'}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
      <Descriptions layout="vertical" title={<Typography.Text style={{ fontSize: '16px' }}>Issuing Institution</Typography.Text>} style={{ marginTop: 15 }}>
        <Descriptions.Item label="Institution Name" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.issuingInstitution?.entityName || 'N/A'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        column={2}
        layout="vertical"
        title={<Typography.Text style={{ fontSize: '16px' }}>Credential Details</Typography.Text>}
        style={{ marginTop: 15 }}
        className="w-[600px]"
      >
        <Descriptions.Item label="Degree Title" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.credentialTitle || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Program (if applicable)" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.program || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Name on Credential" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.nameOnCredential || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Credential Issued Date" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.dateCredentialIssuedAt ? FormatDate(props.applicationDetails?.dateCredentialIssuedAt) : 'N/A'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        layout="vertical"
        style={{ marginTop: 15 }}
        title={<Typography.Text style={{ fontSize: '16px' }}>Where do you want to send this credentials?</Typography.Text>}
      >
        <Descriptions.Item label="Institution Name" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.issuingInstitution?.entityName || 'N/A'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions style={{ marginTop: 20 }}>
        <Descriptions.Item label="">
          <LegalCertification />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};
